import axios from 'axios'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { GLOBAL_ERROR } from 'core/constants/translations/error'
import type { ResponseApiError } from 'core/models/axios-error'

interface TakeDirectorTrajectoryPhotoVariables {
  storeId: number
  year: number
}

export const useApiTakeDirectorTrajectoryPhoto = () => {
  const { t } = useTranslation()

  return useMutation<void, ResponseApiError, TakeDirectorTrajectoryPhotoVariables>({
    mutationFn: async ({ storeId, year }) => {
      await axios.post(`/v1/stores/${storeId}/trajectories/year/${year}`)
    },
    onSuccess: () => {
      toast.success(t('general.trajectory.store.validate.succesful'))
    },
    onError: () => {
      toast.error(t(GLOBAL_ERROR))
    }
  })
}
